import * as faceapi from 'face-api.js';

import React, { PropsWithChildren, useEffect, useState } from 'react';

import GlobalContext from '@/globalContext';
import CircularLoading from '@components/loading';

const modelURL = '/static/models';

interface TinyFaceProps {
    onError: (error: Error) => void;
}

const TinyFace = ({ onError, children }: PropsWithChildren<TinyFaceProps>) => {
    const [tinyFaceError, setTinyFaceError] = useState<Error>();
    const { isTinyFaceReady, setIsTinyFaceReady } = React.useContext(GlobalContext);

    useEffect(() => {
        if (!isTinyFaceReady || tinyFaceError) {
            faceapi.nets.tinyFaceDetector
                .load(modelURL)
                .then(() => {
                    setIsTinyFaceReady(true);
                })
                .catch((error: Error) => {
                    setTinyFaceError(error);
                    onError(error);
                });
        }
    }, [isTinyFaceReady, setIsTinyFaceReady, tinyFaceError, setTinyFaceError, onError]);

    return <>{!tinyFaceError && isTinyFaceReady ? children : <CircularLoading />}</>;
};

export default TinyFace;
